import "../pages/styles.css";

import React from "react";
import check from "../images/check.svg";
import { colors } from "../theme";
import { navigateTo } from "../utils/navigateTo";
import styled from "styled-components";

const Button = styled.div`
  background: ${(p) => (p.accent ? colors.primary : "#c4c4c4")};
  padding: 18px;
  color: ${(p) => (p.accent ? "white" : "#000000")};
  border-radius: 50px;
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;w
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  width: 100%;
  &:hover {
    filter: brightness(90%);
  }
  @media (max-width: 1000px) {
    font-size: 16px;
  }
`;

const IconWrapper = styled.div`
  background: ${colors.primary};
  border-radius: 12px;
  min-height: 16px;
  min-width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.img`
  height: 12px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
`;

const PlansGrid = styled.div`
  display: grid;
  grid-gap: 25px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 30px;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
  @media (max-width: 680px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;

const PlanContainer = styled.div`
  background: white;
  padding: 30px;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`;

const Price = styled.div`
  font-size: 50px;
  font-weight: 800;
  color: ${(p) => (p.accent ? colors.primary : colors.default)};
  @media (max-width: 1000px) {
    font-size: 50px;
  }
`;

const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 25px;
`;

const FeatureRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FeatureText = styled.div`
  font-size: 16px;
  font-weight: 300;
`;

const Subtext = styled.div`
  font-size: 42px;
  font-weight: 400;
  line-height: 1;
  color: black;
  text-align: center;
  width: 100%;
  margin-bottom: 70px;
  @media (max-width: 1000px) {
    font-size: 28px;
    text-align: center;
    padding-top: 10px;
  }
`;

const free = {
  name: "Starter",
  key: "trial",
  price: "Free",
  frequency: "",
  buttonText: "Start For Free",
  description: "Build your first app for free",
  onClick: () => navigateTo("signup", "app"),
  features: [
    "Unlimited Apps",
    "Unlimited Users",
    "1,000 Monthly Operations",
    "250 AI Credits",
    "Community Support",
    "Frontly Branding",
  ],
};

const basic = {
  name: "Basic",
  key: "basic",
  price: "$30",
  frequency: "monthly",
  buttonText: "Get Started",
  description: "Build your first app for free",
  accent: true,
  onClick: () => navigateTo("signup", "app"),
  features: [
    "Unlimited Apps",
    "Unlimited Users",
    "10,000 Monthly Operations",
    "1,000 AI Credits",
    "Team Support",
    "1 Custom Branded App",
  ],
};

const pro = {
  name: "Professional",
  key: "professional",
  price: "$100",
  frequency: "monthly",
  buttonText: "Get Started",
  description: "Build your first app for free",
  onClick: () => navigateTo("signup", "app"),
  features: [
    "Unlimited Apps",
    "Unlimited Users",
    "50,000 Monthly Operations",
    "5,000 AI Credits",
    "Priority Support",
    "3 Custom Branded Apps",
    "API Access",
  ],
};

const enterprise = {
  name: "Enterprise",
  key: "enterprise",
  price: "Custom",
  frequency: "",
  buttonText: "Contact Us",
  description: "Build your first app for free",
  onClick: () => window.open("https://demo-request.frontly.ai"),
  features: ["Custom Limits", "Personalized Onboarding", "Priority Support"],
};

export const Pricing = () => {
  let plans = [free, basic, pro, enterprise];

  return (
    <Container>
      <Subtext id="pricingSection">
        Build unlimited apps for free, with no time limit.
      </Subtext>
      <PlansGrid planCount={plans.length}>
        {plans.map((plan, i) => (
          <PlanContainer key={i} accent={plan.accent}>
            <div>
              <Name accent={plan.accent}>{plan.name}</Name>

              <PriceRow>
                <Price accent={plan.accent}>{plan.price}</Price>
                <PriceFrequency>{plan.frequency}</PriceFrequency>
              </PriceRow>

              <Button accent={plan.accent} onClick={plan.onClick}>
                {plan.buttonText}
              </Button>

              <FeaturesContainer>
                {plan.features.map((feature, fi) => (
                  <FeatureRow key={fi}>
                    <IconWrapper>
                      <Icon src={check} />
                    </IconWrapper>
                    <FeatureText>{feature}</FeatureText>
                  </FeatureRow>
                ))}
              </FeaturesContainer>
            </div>
          </PlanContainer>
        ))}
      </PlansGrid>
    </Container>
  );
};

export default Pricing;

const Name = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.default};
`;

const PriceFrequency = styled.div`
  font-size: 16px;
  font-weight: 300;
  color: ${colors.default};
`;
